import classNames from "classnames";
import React from "react";
import { pushEvent } from '../utilities/analytics';
import { ROOM_NUM_INCREASE } from '../constants/analyticEvents';

export default function Counter(props) {
  const {
    max = 99,
    min = 1,
    onChange,
    value,
    showValue = true,
    disabled = false,
    type = '',
    variant
  } = props;

  if (value < min) {
    onChange(min);
  }

  const onMinusClick = () => {
    onChange(value - 1);
  }

  const onPlusClick = () => {
    onChange(value + 1);
    if (type && type === 'rooms') {
      pushEvent(ROOM_NUM_INCREASE, { roomNum: value + 1 });
    }
  }

  return (
    <div className={classNames('form-counter', { disabled, 'move-form-counter rounded-lg': variant })}>
      <button
        className="form-counter__button minus"
        onClick={onMinusClick}
        disabled={value === min}
      />
      {showValue && <span className="form-counter__value">{value}</span>}
      <button
        className="form-counter__button plus"
        onClick={onPlusClick}
        disabled={value >= max}
      />
    </div>
  );
}
